import { ObjectTools } from '../../tools/object-tools';

export class SolText {
  private constructor(
    public readonly text: string,
    public readonly translatable: boolean,
    public readonly params: Record<string, any>,
  ) {}

  public static empty(): SolText {
    return new SolText('', false, {});
  }

  public static of(text: string, params: Record<string, any> = {}): SolText {
    return new SolText(text, true, params);
  }

  public static ofRaw(text: string): SolText {
    return new SolText(text, false, {});
  }

  public isEmpty(): boolean {
    return this.text.length === 0;
  }

  public withText(text: string): SolText {
    return this.copy({ text });
  }

  public withTranslatable(translatable: boolean): SolText {
    return this.copy({ translatable, params: translatable ? this.params : {} });
  }

  public withParams(params: Record<string, any>): SolText {
    return this.copy({ translatable: true, params });
  }

  private copy(props: Partial<SolText>): SolText {
    return ObjectTools.copy<SolText>(this, props);
  }
}
